import { IPCEventType } from '@electron/shared/ipc.types';
import {
  MeetingIntentDetectedPayloadSchema,
  MeetingIntentOverlayResolutionSchema,
  type MeetingIntentDetectedPayload,
  type MeetingIntentOverlayResolution,
} from '@electron/shared/meetings.types';

import { ElectronAPI } from '../base/ElectronAPI';

import type { ElectronListenerMethod } from '../base/types';

export class MeetingIntentOverlayAPI extends ElectronAPI {
  show(payload: MeetingIntentDetectedPayload): Promise<void> {
    return this.invoke<void>(IPCEventType.meetingIntentOverlayShow, payload);
  }

  ready(): void {
    this.ipcRenderer?.send(IPCEventType.meetingIntentOverlayReady);
  }

  presented(payload: MeetingIntentDetectedPayload): Promise<void> {
    return this.invoke<void>(
      IPCEventType.meetingIntentOverlayPresented,
      payload
    );
  }

  resolve(resolution: MeetingIntentOverlayResolution): Promise<void> {
    return this.invoke<void>(
      IPCEventType.meetingIntentOverlayResolve,
      resolution
    );
  }

  listenWillShow: ElectronListenerMethod<IPCEventType.meetingIntentOverlayWillShow> =
    (callback) =>
      this.addListener({
        eventType: IPCEventType.meetingIntentOverlayWillShow,
        callback,
        payloadValidator: MeetingIntentDetectedPayloadSchema,
        once: false,
      });

  listenPresented: ElectronListenerMethod<IPCEventType.meetingIntentOverlayPresented> =
    (callback) =>
      this.addListener({
        eventType: IPCEventType.meetingIntentOverlayPresented,
        callback,
        payloadValidator: MeetingIntentDetectedPayloadSchema,
        once: false,
      });

  listenResolution: ElectronListenerMethod<IPCEventType.meetingIntentOverlayResolve> =
    (callback) =>
      this.addListener({
        eventType: IPCEventType.meetingIntentOverlayResolve,
        callback,
        payloadValidator: MeetingIntentOverlayResolutionSchema,
        once: false,
      });
}
